import type { PageContext } from 'vike/types'

const ARTICLE_PATH_PATTERN = /^\/help\/([\w~-]+)(?:\/([\w-]*))?\/?$/

export function route(pageContext: PageContext) {
  const match = pageContext.urlPathname.match(ARTICLE_PATH_PATTERN)
  if (!match) {
    return false
  }
  return { routeParams: { id: match[1], slug: match[2] ?? '' } }
}
